import { useEffect, useMemo } from 'react';


export const useLocationFilter = ({
    selectedCompany,
    setValue,
    fieldArrayName,
    locationFieldName,
    resetValue = null,
    filterKey = '&company_id.in',
    isDirty = false
}) => {

    // Reset location value when company changes
    useEffect(() => {
        if (setValue && fieldArrayName && locationFieldName && isDirty) {
            setValue(`${fieldArrayName}.${locationFieldName}`, resetValue);
        }
    }, [isDirty, setValue, fieldArrayName, locationFieldName, resetValue]);

    const locationFilter = useMemo(() => {
        const companyId = Array.isArray(selectedCompany) ? (selectedCompany?.length ? selectedCompany : null) : (selectedCompany || null);

        if (companyId === null) {
            return {};
        }

        return {
            [filterKey]: companyId
        };
    }, [selectedCompany, filterKey]);

    return locationFilter;
};



export const useMultipleLocationFilters = ({
    selectedCompany,
    setValue,
    fieldConfigs,
    resetValue = undefined,
    filterKey = '&company_id.in'
}) => {
    return useMemo(() => {
        const companyId = selectedCompany?.length > 0 ? selectedCompany : 0;

        // Reset all location fields
        fieldConfigs.forEach(({ fieldArrayName, locationFieldName }) => {
            if (setValue && fieldArrayName && locationFieldName) {
                setValue(`${fieldArrayName}.${locationFieldName}`, resetValue);
            }
        });

        return {
            [filterKey]: companyId
        };
    }, [selectedCompany, setValue, fieldConfigs, resetValue, filterKey]);
};

export default {
    useLocationFilter,
    useMultipleLocationFilters
}